import CountUp from 'react-countup';

const CountUpComp = (props: any) => {
  const { end, suffix } = props;
  return (
    <CountUp
      duration={0.4}
      end={end}
      redraw={true}
      suffix={suffix || ''}
      enableScrollSpy
      separator=','
    />
  );
};

export default CountUpComp;
